module.exports = __webpack_public_path__ + "img/svg/background-create-match-modal.27a4132273bb1ec11efda60bf2b65e2e.svg";